
/**
 "customer_details": {
      "name": "John Smith",
      "email": "jsmith@gmail.com",
      "street1": "404, 11th st, void",
      "city": "Sharjja",
      "country": "JO",
      "ip": "176.28.144.51"
    }
 */
/**
 * @param {string} clientKey - PayTabs Client Key
 * @param {function} callBackFunction -- CallBackFUnction triggered on submiting the form
 * @param {function} notifyCardTypeFunction -- CallBack Function to notify what is the type of the card
 * @param {function} clearErrorsFunction -- Function to handle clearing validation error from ur form
 * @param {object} context -The current context (pass 'this' keyword)
 */
function payTabsInit(clientKey, callBackFunction,notifyCardTypeFunction,clearErrorsFunction,context) {

  var myform = document.getElementById('payform');
  if (myform) {


    paylib.inlineForm({
      'key': clientKey,
      'form': myform,
      'autosubmit': true,
      'notifyCardType':notifyCardTypeFunction.bind(context),
      'clearErrors':clearErrorsFunction.bind(context),
    //   notifyCardType: function(ct, accepted) {
    //     hpp.form.identify(ct, accepted);
    // },
      //    'callback': function (response) {
      //
      //      this.onSubmitPayTabs(response);
      //    if (response.error) {
      //      paylib.handleError(document.getElementById('paymentErrors'), response);
      //    }
      //  }.bind(ang),

    // 'callback':response => {
    //
    //         this.onSubmitPayTabs(response);
    //       },

      'callback':callBackFunction.bind(context),

      // 'callback': response => {
      //
      //   // JSON.stringify( $("#payform").serializeArray() );
      //   let arrayData=$("#payform").serializeArray();
      //   arrayData.push({name:'payTabsToken',value:response.token})
      //   let data={};
      //   arrayData.forEach( item=>{
      //     data[item.name]=item.value;
      //   })
      //
      //   data["depositeTypeEnum"]=parseInt(data["depositeTypeEnum"]);
      //   data["paymentMethod"]=parseInt(data["paymentMethod"]);
      //   data["paymentMode"]=parseInt(data["paymentMode"]);
      //   data["rentalServiceDeliveryChannel"]=parseInt(data["rentalServiceDeliveryChannel"]);
      //   data["payTabsCustomerDetails"]=customerDetails;
      //   var xmlhttp = new XMLHttpRequest();   // new HttpRequest instance
      //   var theUrl = apiBaseUrl+"Payment/ProceedPayment";
      //   xmlhttp.open("POST", theUrl);
      //   xmlhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      //   xmlhttp.onreadystatechange = function() {
      //     if (xmlhttp.readyState == XMLHttpRequest.DONE) {
      //         alert(xmlhttp.responseText);
      //     }
      // }
      //
      //   xmlhttp.send(JSON.stringify(data));
      //   //this.onSubmitPayTabs(response);
      // }

    });
    paylib._payform.autosubmit = false;
  }
}
